import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import Modal from "react-modal";
import { themeSelector } from "../ducks/shopping/selectors";

const Container = styled.div`
  padding: ${(props) => props.padding};
  overflow: auto;
  background-color: ${(props) => props.bgColor || "#fff" }; // exress //
  min-height: 100vh; // exress //
  height: 100%; // exress //
`;

Modal.setAppElement("#root");

export default function Drawer({ isOpen, onClose, children, padding }) {

  const theme = useSelector(themeSelector);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      closeTimeoutMS={300}
      contentLabel="Drawer menu"
      className="drawer"
    >
      <Container padding={padding} bgColor={theme && theme.bodyBackgroundGeneral}>{children}</Container>
    </Modal>
  );
}

Drawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
  padding: PropTypes.string,
};
Drawer.defaultProps = {
  padding: "16px",
};
